module.exports = __webpack_public_path__ + "img/43.6242cf44.jpg";